type FocusVisibilityHandlers = {
  handleOffFocus: () => void;
  handleOnFocus: () => {};
};

export const useFocusVisibilityStatus = ({ handleOffFocus, handleOnFocus }: FocusVisibilityHandlers) => {
  const handleVisibilityChange = () => {
    if (document?.visibilityState === 'visible') {
      handleOnFocus();
    } else {
      handleOffFocus();
    }
  };

  const setupFocusVisibilityListeners = () => {
    window?.addEventListener('focus', handleOnFocus);
    window?.addEventListener('blur', handleOffFocus);
    document?.addEventListener('visibilitychange', handleVisibilityChange);
  };

  const cleanupFocusVisibilityListeners = () => {
    window?.removeEventListener('focus', handleOnFocus);
    window?.removeEventListener('blur', handleOffFocus);
    document?.removeEventListener('visibilitychange', handleVisibilityChange);
  };

  return {
    cleanupFocusVisibilityListeners,
    setupFocusVisibilityListeners,
  };
};
